module.exports = __webpack_public_path__ + "static/media/nogersund.6701b98d.jpeg";